import { render, staticRenderFns } from "./product_material_list.vue?vue&type=template&id=9141eb04&scoped=true"
import script from "./product_material_list.vue?vue&type=script&lang=js"
export * from "./product_material_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9141eb04",
  null
  
)

export default component.exports